module.exports = __webpack_public_path__ + "fonts/Adelle_light.03c57417.woff";